<template>
  <div>
    <el-button size="small" @click="openDialog">添加</el-button>
    <el-button size="small" @click="removeSchedule">移除</el-button>
    <span class="total" v-if="value && value.length">共{{value.length}}个</span>
    <el-dialog
      title="选择计划单"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :inline="true">
        <el-form-item label="计划单号">
          <el-input v-model="form.scheduleNo" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="计划名称">
          <el-input v-model="form.scheduleName" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handeReset">重置</el-button>
      </el-form>
      <div style="margin: 16px"></div>
      <Table
        v-loading="loading"
        :props="table.props"
        ref="table"
        style="border-right: 1px solid #EBEEF5"
        :header="table.header.filter((item) => item.show)"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="12">
            <pagination
              style="float: left"
              v-bind:currentpage="currentPage"
              v-bind:pagesize="pageSize"
              v-bind:totalcount="totalCount"
              @handle-size-change="handleSizeChange"
              @handle-current-change="handleCurrentChange"
            ></pagination>
          </el-col>
          <el-col :span="12">
<!--            已选 <span style="color: #FF8B00;padding:0 5px">{{ selectedRow.length }} </span>条-->
            <el-button
              @click="dialogVisible=!dialogVisible"
            >取 消</el-button
            >
            <el-button
              type="primary"
              :disabled="selectedRow.length === 0"
              @click="handleConfirm"
              >确 定</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: []
    },
    orderNo: {
      type: String
    },
    scheduleInfo: {
      type: Object
    },
    item: {
      type: Object
    },
    index: {
      type: Number,
      deafult: 0
    },
    ruleList: {
      type: Array,
      deafult: []
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      form: this.genDefaultForm(),
      dialogVisible: false,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            prop: 'scheduleNo',
            label: '计划单号',
            show: true,
            'min-width': '150',
            'show-overflow-tooltip': true
          },
          {
            prop: 'scheduleName',
            label: '计划名称',
            show: true,
            'min-width': '160',
            'show-overflow-tooltip': true
          },
          // {
          //   prop: 'subFrequency',
          //   label: 'N+UV',
          //   show: true,
          //   'min-width': '120',
          //   formatter: params => {
          //     return params.subFrequency !== 1
          //       ? this.$consts.frequencyText[params.subFrequency] + params.subTrafficDaily + '次'
          //       : this.$consts.frequencyText[params.subFrequency]
          //   }
          // },
          {
            prop: 'scheduleId',
            label: '计划ID',
            show: false
          },
          {
            prop: 'adOrder.orderNo',
            label: '订单编号',
            show: true,
            'min-width': '150'
          },
          {
            prop: 'adOrder.orderName',
            label: '订单名称',
            show: true,
            'min-width': '160'
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: []
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue) {
        this.handleSearch()
      }
      this.selectedRow = []
      this.table.selected = []
      this.table.data = []
      this.selected = []
      this.form = this.genDefaultForm()
    }
  },
  methods: {
    removeSchedule() {
      this.$emit('remove', this.index)
    },
    openDialog() {
      if (this.scheduleInfo.unionFreqType === 2 && !this.scheduleInfo.trafficDaily) {
        return this.$message.error('请先填写频次')
      }
      this.dialogVisible = true
    },
    genDefaultForm() {
      return {
        orderNoOrName: this.orderNo,
        scheduleNo: undefined,
        scheduleName: undefined,
        scheduleStatus: undefined
      }
    },
    fetchData() {
      this.loading = true
      let scheduleIds = this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.BatchBusiness.scheduleIds
      let ids = []
      this.ruleList.forEach(item => {
        (item.data || []).forEach(it => {
          ids.push(it.scheduleId)
        })
      })
      scheduleIds = scheduleIds.filter(item => !ids.includes(item))
      if (scheduleIds.length === 0) {
        scheduleIds = [0]
      }
      const filter = {
        ...this.form,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        scheduleIds: scheduleIds,
      }
      this.$service.getScheduleList(filter).then(data => {
        this.table.data = data.rows || []
        this.totalCount = data.total || 0
        this.updateTableSelected()
        this.loading = false
      })
        .catch(() => {
          this.loading = false
        })
    },

    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.scheduleId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter(item => {
        return item !== targetItem.scheduleId
      })
      this.selectedRow = this.selectedRow.filter(item => {
        return item.scheduleId !== targetItem.scheduleId
      })
      this.updateTableSelected()
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.scheduleId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchData()
    },
    handeReset() {
      this.form = this.genDefaultForm()
      this.pageSize = 10
      this.fetchData()
    },
    handleCleanAll() {
      this.$emit('clean-all', true)
    },
    handleConfirm() {
      this.$emit('confirm', this.selectedRow, this.index)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.total {
  margin-left 10px
  font-size 12px;
  color rgba(0,0,0,0.85)

}
.order-search-item
  margin-bottom 16px
  .el-form-item
    width 50%
    >>>.el-form-item__content
      width calc(100% - 80px)
</style>
